import API from "@/API";
import moment from "@/utils/moment";

const GRANTED_TYPES = ["Manager"];
const SET_USER = "SET_USER";

export default {
  namespaced: true,

  state: {
    user: null
  },

  actions: {
    decodeToken({ commit }, token) {
      let base64Url = token.split(".")[1];
      let base64 = base64Url.replace("-", "+").replace("_", "/");
      return JSON.parse(window.atob(base64));
    },

    async getUser({ commit }, user_id) {
      try {
        let user = await API.User.searchById(user_id);
        commit("SET_USER", user);
      } catch (e) {
        throw e;
      }
    },

    async authentication({ commit }, creds) {
      try {
        let response = await API.Authentication.authenticate(creds);
        response = response.data.data;

        if (GRANTED_TYPES.indexOf(response.account.accountable_type) != -1) {
          localStorage.authentication = response.token;
          commit("SET_USER", response.account);
        } else {
          throw "Você não tem acesso à esta aplicação";
        }

        return true;
      } catch (e) {
        throw "Usuário e/ou senha incorretos";
      }
    },

    async isAuthenticated({ dispatch, state }) {
      try {
        let authentication = localStorage.authentication;

        if (!authentication && !state.user) throw "Não autorizado";

        let token_data = await dispatch("decodeToken", authentication);
        let expires_at = moment(token_data.exp * 1000);

        if (expires_at < moment()) {
          let checkToken = await API.Authentication.checkToken();
          if (!checkToken) throw "Não autorizado";
        }
        if (!state.user) await dispatch("getUser", token_data.user_id);

        return true;

        throw "Não autorizado";
      } catch (e) {
        dispatch("clearToken");
        return false;
      }
    },

    clearToken({ commit }) {
      localStorage.removeItem("authentication");
      commit("SET_USER", null);
    }
  },

  mutations: {
    [SET_USER](state, payload) {
      state.user = payload;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js